export default (address) => {
  return `${address.street || address.streetAddress} ${address.number || ''},
    ${address.city}, ${address.state}, ${address.postalCode}`;
};



// WEBPACK FOOTER //
// ./src/lib/consumer-fields/text-from-address.js